import { Component, OnDestroy, OnInit } from '@angular/core'
import { MatDialogRef } from '@angular/material/dialog'
import { TouaregControlComponent } from '../touareg-control/touareg-control.component';

@Component({
  selector: 'app-touareg-control-dialog',
  templateUrl: './touareg-control-dialog.component.html',
  styleUrls: ['./touareg-control-dialog.component.scss'],
  imports: [TouaregControlComponent],
})
export class TouaregControlDialogComponent {
  constructor(public dialogRef: MatDialogRef<TouaregControlDialogComponent>) {}

  public close() {
    this.dialogRef.close()
  }
}
